import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ConfiguracoesLayer from "../components/ConfiguracoesLayer";
import { useTranslation } from "../i18n/I18nContext";

// Uma só página/componente (ConfiguracoesLayer) serve os 3 links da sidebar
// (Multas/Pagamentos/Pautas) — `initialTab` decide qual separador abre. O
// `key` força o React a remontar o componente ao navegar entre estas rotas
// (senão o React reaproveitava a instância e o `useState(initialTab)" nunca
// era reavaliado).
const ConfiguracoesPage = ({ initialTab = "multas" }) => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("config.breadcrumb")} />
      <ConfiguracoesLayer key={initialTab} initialTab={initialTab} />
    </MasterLayout>
  );
};

export default ConfiguracoesPage;
